import React from "react";
import Button from "../Button";
import { BaseModal } from "./Modal";

type Props = {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
  title: string;
  description: string;
  buttonLabel: string;
};

const RemoveModal = ({
  onConfirm,
  onClose,
  isOpen,
  title,
  description,
  buttonLabel,
}: Props) => {
  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <div className="mt-6 text-start">
        <h1 className="font-bold">{title}</h1>
        <p className="text-sm mb-4 mt-2">{description}</p>
        <div className="flex flex-row justify-between mt-4">
          <Button
            label="Cancelar"
            type="transparent"
            onClick={onClose}
            classNames="w-full justify-center"
          />
          <Button
            label={buttonLabel}
            type="destructive"
            onClick={onConfirm}
            classNames="w-full justify-center"
          />
        </div>
      </div>
    </BaseModal>
  );
};

export default RemoveModal;
